<template>
    <base-page :model="model.heroSection" box-shadow>
        <div class="contact-page">
            <template v-if="!isSubmitted">
                <div class="contact-page-info-section">
                    <h2>{{ model.hospiceSection.title }}</h2>
                    <p>{{ model.hospiceSection.description }}</p>
                    <Button as-child>
                        <a :href="model.hospiceSection.link.url">
                            {{ model.hospiceSection.link.text }}
                        </a>
                    </Button>
                </div>
                <div class="form-description">
                    <h2>{{ model.formSection.title }}</h2>
                    <span v-html="model.formSection.description"></span>
                </div>
            </template>
            <contact-form v-if="model.formSection" :model="model.formSection" :isSubmitted="isSubmitted"
                :onIsSubmittedChange="onIsSubmittedChange">
            </contact-form>
            <div v-else>Can't get form data</div>
        </div>
    </base-page>
</template>

<script setup lang="ts">
import { ref } from "vue"
import ContactForm from "./components/ContactForm.vue"
import type { IContactProps } from "./Contact.model"
import { Button } from "@/components/ui/button"
const isSubmitted = ref(false)
const { model } = defineProps<IContactProps>()
const onIsSubmittedChange = (value: boolean) => {
    isSubmitted.value = value
}
</script>

<style lang="scss" scoped>
.contact-page {
    border-radius: 0 0 24px 24px;
    border: 1px solid lightgray;
    border-top: 0;
    padding: 24px 30px;

    h2 {
        font-weight: 700;
        font-size: 24px;
        margin-bottom: 3px;
    }
}

.form-description {
    :deep(a) {
        color: var(--primary);
    }
}

.contact-page-info-section {
    display: flex;
    flex-direction: column;
    width: fit-content;
    gap: 5px;
    margin-bottom: 15px;
}

:deep(.thank-you-message a) {
    color: var(--primary);
    font-weight: 600;
}
</style>
